import React from "react";
import { AbsoluteFill, Audio, Sequence, staticFile } from "remotion";
import { SCENE } from "./constants";
import { Scene01Hook } from "./Scene01Hook";
import { Scene02Problem } from "./Scene02Problem";
import { Scene03MeetEAKC } from "./Scene03MeetEAKC";
import { Scene04Sources } from "./Scene04Sources";
import { Scene05AskAnything } from "./Scene05AskAnything";
import { Scene06Modes } from "./Scene06Modes";
import { Scene07Citations } from "./Scene07Citations";
import { Scene08Graph } from "./Scene08Graph";
import { Scene09Admin } from "./Scene09Admin";
import { Scene10Stats } from "./Scene10Stats";
import { Scene11Security } from "./Scene11Security";
import { Scene12CTA } from "./Scene12CTA";

export const EAKCProductVideo: React.FC = () => {
  return (
    <AbsoluteFill style={{ backgroundColor: "#0A0E1A" }}>
      {/* Voiceover audio */}
      <Audio src={staticFile("eakc-voiceover.mp3")} volume={1} />

      <Sequence from={SCENE.hook.start} durationInFrames={SCENE.hook.duration}>
        <Scene01Hook />
      </Sequence>

      <Sequence from={SCENE.problem.start} durationInFrames={SCENE.problem.duration}>
        <Scene02Problem />
      </Sequence>

      <Sequence from={SCENE.meetEAKC.start} durationInFrames={SCENE.meetEAKC.duration}>
        <Scene03MeetEAKC />
      </Sequence>

      <Sequence from={SCENE.sources.start} durationInFrames={SCENE.sources.duration}>
        <Scene04Sources />
      </Sequence>

      <Sequence from={SCENE.askAnything.start} durationInFrames={SCENE.askAnything.duration}>
        <Scene05AskAnything />
      </Sequence>

      <Sequence from={SCENE.modes.start} durationInFrames={SCENE.modes.duration}>
        <Scene06Modes />
      </Sequence>

      <Sequence from={SCENE.citations.start} durationInFrames={SCENE.citations.duration}>
        <Scene07Citations />
      </Sequence>

      <Sequence from={SCENE.graph.start} durationInFrames={SCENE.graph.duration}>
        <Scene08Graph />
      </Sequence>

      <Sequence from={SCENE.admin.start} durationInFrames={SCENE.admin.duration}>
        <Scene09Admin />
      </Sequence>

      <Sequence from={SCENE.stats.start} durationInFrames={SCENE.stats.duration}>
        <Scene10Stats />
      </Sequence>

      <Sequence from={SCENE.security.start} durationInFrames={SCENE.security.duration}>
        <Scene11Security />
      </Sequence>

      <Sequence from={SCENE.cta.start} durationInFrames={SCENE.cta.duration}>
        <Scene12CTA />
      </Sequence>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
